// extracted by mini-css-extract-plugin
export default {"modalityList":"ModalityList_modalityList__vVbxN","modalityListItem":"ModalityList_modalityListItem__-SOev"};